import * as blood from './blood'
import * as lab from './lab'
import * as printDoc from './print.doc'
import * as printLabel from './print.label'
import * as configProfile from './config-profile'

export default Object.freeze({
  ...blood,
  ...lab,
  ...printDoc,
  ...printLabel,
  ...configProfile
})
